interface InactivityWarningProps {
  warningLeadMinutes: number;
  onExtend: () => void;
  onSignOut: () => void;
}

export function InactivityWarning({ warningLeadMinutes, onExtend, onSignOut }: InactivityWarningProps) {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-[14px] border border-slate-200 bg-white p-4 shadow-2xl dark:border-slate-700 dark:bg-slate-900">
        <div className="flex items-start gap-3 mb-4">
          <span className="material-symbols-outlined text-amber-600 text-2xl sm:text-3xl shrink-0 mt-0.5">warning</span>
          <h2 className="text-lg sm:text-xl font-bold font-heading uppercase tracking-caps-md text-slate-900">
            Session Timeout Warning
          </h2>
         </div>
         <p className="text-amber-600 text-xs sm:text-sm mb-6 leading-relaxed">
           You will be signed out in {warningLeadMinutes} minute{warningLeadMinutes === 1 ? "" : "s"} due to inactivity. Click "Stay Signed In" to continue your session.
         </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onExtend}
            className="flex-auto rounded-lg bg-orange-600 px-5 py-3 text-sm font-bold uppercase tracking-caps-md text-white transition-opacity hover:opacity-90"
          >
            Stay Signed In
          </button>
          <button
            onClick={onSignOut}
            className="flex-auto rounded-lg border border-red-700/30 bg-transparent px-5 py-3 text-sm font-bold uppercase tracking-caps-md text-red-600 transition-colors hover:bg-red-50 dark:hover:bg-red-950/30"
          >
            Sign Out Now
          </button>
        </div>
      </div>
    </div>
  );
}
